import { render, staticRenderFns } from "./OrderCreateDialog.vue?vue&type=template&id=1553db5f&scoped=true"
import script from "./OrderCreateDialog.vue?vue&type=script&lang=js"
export * from "./OrderCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateDialog.vue?vue&type=style&index=0&id=1553db5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1553db5f",
  null
  
)

export default component.exports